module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("749O7"))).then(() => parcelRequire('hEqeo'));